import { useQuery } from '@tanstack/react-query'

import { apiClient } from '@/lib/api-client'

import type { Get2FaStatusResponse } from './2fa.types'

const get2FaStatus = async (): Promise<Get2FaStatusResponse> => {
  const response = await apiClient.get<Get2FaStatusResponse>(
    '/v1/administration/user/2fa',
  )
  return response.data
}

export const useGet2FaStatus = () => {
  return useQuery({
    queryKey: ['user-2fa-status'],
    queryFn: () => get2FaStatus(),
  })
}
